<template>
<router-link class="menuitem animate_class" :to="data.link">

<template v-if="data.key=='menuseperator'">
<div class="menuseperator  animate_class" :style="'display:'+menuleftopposite">
  <i class="pi pi-minus"></i></div>

<div :style="'opacity:'+menuleftopacity+';display:'+menuleft" class="menuseperatortitle pl-2 pr-2 animate_class" >{{$store.state.languages.lang_phrases[data.title] }}</div>

</template>


<template v-else>
<!-- with badge-->
<div class="menuitemcapital raised_item animate_class" 
v-tooltip="{ value: $store.state.languages.lang_phrases[data.title], disabled: showtooltip,class: 'custom-tooltip' }"
:class="{'menuitemcapital_active':data.key==$store.state.ui.activemenuitem }"
v-if="show_bange"
 v-badge.danger="ticketcount"
>{{capital}}</div>
<!-- with badge-->
<!-- without badge-->
<div class="menuitemcapital raised_item animate_class" 
v-tooltip="{ value: $store.state.languages.lang_phrases[data.title], disabled: showtooltip,class: 'custom-tooltip' }"
:class="{'menuitemcapital_active':data.key==$store.state.ui.activemenuitem }"
v-else
>{{capital}}</div>
<!-- without badge-->


<div :style="'opacity:'+menuleftopacity+';display:'+menuleft" class="menuitemtitle pl-2 pr-2 animate_class" >{{$store.state.languages.lang_phrases[data.title] }}</div>
 
</template>




</router-link>
</template>

<script>
export default {

  name: 'leftSidebarItem',
  props:["data"],
  data () {
    return {
      show_bange:false,
    }
  },
   computed:{
    ticketcount()
    {
      if(this.$store.state.tickets.admin_open_tickets)
      {
        if(this.$store.state.tickets.admin_open_tickets_count>9)
        {
          return "9+"
        }
        else
        {
          return this.$store.state.tickets.admin_open_tickets_count
        }
      }
      else
      {
        return ""
      }
    },
    capital()
    {
      let capital
      if(this.$store.state.languages.lang_phrases)
      {

        let term = this.$store.state.languages.lang_phrases[this.data.title]
        if(term)
        {
          capital = term.charAt(0);
          capital = capital.toUpperCase();
        }
        else
        {
          capital = this.data.capital
        }
        
      }
      else
      {
        capital = this.data.capital
      }
      
      return capital
    },
  	menuleft()
    {
      if(this.$store.state.ui.viewdevice=="mobile")
      {
        return "block"
      }
      else
      {
        if(this.$store.state.ui.menuopen)
        {
          return "block"
        }
        else{
          return "none"
        }
      }     
    },
    menuleftopposite()
    {
      if(this.$store.state.ui.viewdevice=="mobile")
      {
        return "none"
      }
      else
      {
        if(this.$store.state.ui.menuopen)
        {
          return "none"
        }
        else{
          return "block"
        }
      }     
    },
    menuleftopacity()
    {
      if(this.$store.state.ui.viewdevice=="mobile")
      {
        return 100
      }
      else
      {
        if(this.$store.state.ui.menuopen)
        {
          return 100
        }
        else{
          return 0
        }
      }  
    },
  	showtooltip()
  	{
  		if(this.$store.state.ui.menuopen)
  		{
  			return true
  		}
  		else{
  			return false
  		}
  	},
    admin_open_tickets()
    {
      if(this.data.key=="tickets" && this.$store.state.tickets.admin_open_tickets)
      {
        this.show_bange = true
      }
      return this.$store.state.tickets.admin_open_tickets
    }
  },
  watch:
  {
    admin_open_tickets(newVal)
    {

      if(newVal)
      {        
        if(this.data.key=="tickets")
        {
          this.show_bange = true
        }
        
      }
      else
      {       
        if(this.data.key=="tickets")
        {
          this.show_bange = false
        }
      }
    }
  },
};
</script>

<style lang="css" scoped>
</style>